import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 28,
    objectFit: 'contain',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <img
      className={classes.img}
      src="/phoenix-avatar.png"
      alt="Iron Phoenix"
    />
  );
};

export default LogoIcon;
